import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Form } from 'antd'
import PasswordChecklistIndicator from 'components/design/Form/PasswordChecklist'
import ButtonBlack from 'components/design/Form/ButtonBlack/index'
import FormInput from '../../design/Form/Input'
import authStyle from '../../../layouts/Auth/style.module.scss'
import style from './style.module.scss'

const ResetPasswordForm = ({ footer }) => {
  const [form] = Form.useForm()
  const [password, setPassword] = useState('')
  const [isPasswordValid, setIsPasswordValid] = useState(false)
  const [repeatPassword, setRepeatPassword] = useState('')
  const [isPasswordFocused, setIsPasswordFocused] = useState(false)
  const user = useSelector(state => state.user)
  const dispatch = useDispatch()

  const onFinish = values => {
    if (values.password === values.repeatPassword) {
      if (isPasswordValid) {
        if (
          values.password.charAt(0) === ' ' ||
          values.password.charAt(values.password.length - 1) === ' '
        ) {
          dispatch({
            type: 'apps/INITIATE_NOTIFICATION',
            payload: {
              type: 'error',
              message: 'Your password can’t start or end with a blank space',
            },
          })
        } else {
          dispatch({
            type: 'user/RESET_PASSWORD',
            payload: values,
          })
        }
      } else {
        dispatch({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: { type: 'error', message: 'Please enter a strong password' },
        })
      }
    } else {
      dispatch({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Password does not match' },
      })
    }
  }

  const handleRepeatPasswordInput = e => {
    setRepeatPassword({ repeatPassword: e.target.value })
  }

  const validatePasswordFields = async (rule, value, callback) => {
    let returnValue = true
    if (password.password === '') {
      callback('Please enter password')
    } else {
      try {
        if (value === '') {
          callback('Please confirm password')
        } else if (value !== '' && value !== password) {
          callback("Passwords didn't match. Try again")
        }
        returnValue = true
      } catch (e) {
        callback(e)
        returnValue = "Passwords didn't match. Try again"
      }
    }
    return returnValue
  }

  const onFocusHandler = () => {
    setIsPasswordFocused(true)
  }
  const onBlurHandler = () => {
    setIsPasswordFocused(false)
  }

  return (
    <div className={style.resetPassword}>
      <div className={style.resetPasswordContent}>
        <div className={style.resetPasswordHeader}>
          <div className={style.resetPasswordTitle}>Set New Password</div>
          <div className={style.resetPasswordSubtitle}>
            Set a strong new password that’s different from your previous ones
          </div>
        </div>
        <div className={style.resetPasswordForm}>
          <Form
            form={form}
            hideRequiredMark
            onFinish={onFinish}
            style={{ width: '100%' }}
            initialValues={{ password }}
          >
            <div className={style.resetPasswordInputWrapper}>
              <div className={authStyle.passwordInputWrapper}>
                <FormInput
                  onChange={e => setPassword(e.target.value)}
                  Form={Form}
                  label={<div className={style.cometchatResetPassInputLabel}>New Password</div>}
                  style={{ height: '44px', borderColor: '#D5D7DA' }}
                  name="password"
                  value={password}
                  placeholder="New Password"
                  rules={[{ required: true, message: 'Please enter a new password' }]}
                  type="password"
                  formItemStyles={{ marginBottom: '12px' }}
                  onFocusHandler={onFocusHandler}
                  onBlurHandler={onBlurHandler}
                />
                <PasswordChecklistIndicator
                  onChange={isValid => {
                    setIsPasswordValid(isValid)
                  }}
                  value={password}
                  valueAgain={repeatPassword}
                  isPasswordFocused={isPasswordFocused}
                  customStyles={{ marginTop: '-4px' }}
                />
                {!isPasswordFocused && <div style={{ height: '4px' }} />}
              </div>
              <div className={authStyle.passwordInputWrapper}>
                <FormInput
                  onChange={handleRepeatPasswordInput}
                  Form={Form}
                  label={
                    <div className={style.cometchatResetPassInputLabel}>Re-Enter New Password</div>
                  }
                  style={{ height: '44px', borderColor: '#D5D7DA' }}
                  name="repeatPassword"
                  value={repeatPassword}
                  placeholder="Re-Enter New Password"
                  rules={[
                    {
                      required: true,
                      validator: validatePasswordFields,
                      message: 'Passwords does not match!',
                    },
                  ]}
                  type="password"
                />
              </div>
            </div>
            <ButtonBlack
              holderStyles={{ width: '100%', marginTop: '24px' }}
              buttonStyles={{
                width: '100%',
                height: '44px',
                fontSize: '16px',
              }}
              buttonText="Set New Password"
              buttonType="submit"
              loading={user.loading}
            />
          </Form>
        </div>
        {footer}
      </div>
    </div>
  )
}

export default ResetPasswordForm
